import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "call-time__text" }
const _hoisted_2 = { class: "call-time__placeholder" }
const _hoisted_3 = {
  key: 0,
  class: "call-duration-hint"
}
const _hoisted_4 = {
  key: 0,
  class: "solid"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcIconSvgWrapper = _resolveComponent("NcIconSvgWrapper")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_IconStop = _resolveComponent("IconStop")
  const _component_NcPopover = _resolveComponent("NcPopover")

  return (_openBlock(), _createBlock(_component_NcPopover, {
    shown: $data.showPopover,
    "onUpdate:shown": _cache[1] || (_cache[1] = $event => (($data.showPopover) = $event)),
    class: "call-time",
    "no-focus-trap": !$options.isShowRecordingControls,
    triggers: []
  }, {
    trigger: _withCtx(() => [
      _createVNode(_component_NcButton, {
        disabled: $options.isButtonDisabled,
        wide: true,
        title: $options.recordingButtonTitle,
        variant: "tertiary",
        onClick: _cache[0] || (_cache[0] = $event => ($data.showPopover = !$data.showPopover))
      }, _createSlots({
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString($options.placeholderCallTime), 1),
            _createElementVNode("span", null, _toDisplayString($options.formattedCallTime), 1)
          ])
        ]),
        _: 2
      }, [
        ($options.isRecording || $options.isStartingRecording)
          ? {
              name: "icon",
              fn: _withCtx(() => [
                _createVNode(_component_NcIconSvgWrapper, {
                  class: _normalizeClass(["call-time__recording-icon", { 'call-time__recording-icon--start': $options.isStartingRecording }]),
                  svg: $setup.IconScreenRecordOutline,
                  size: 20
                }, null, 8, ["class", "svg"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["disabled", "title"])
    ]),
    default: _withCtx(() => [
      ($data.isCallDurationHintShown)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($options.t('spreed', 'The call has been running for one hour.')), 1))
        : _createCommentVNode("", true),
      ($options.isShowRecordingControls)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($data.isCallDurationHintShown)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_4))
              : _createCommentVNode("", true),
            ($options.isStartingRecording)
              ? (_openBlock(), _createBlock(_component_NcButton, {
                  key: 1,
                  variant: "tertiary-no-background",
                  wide: true,
                  onClick: $options.stopRecording
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_NcLoadingIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Cancel recording start')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_NcButton, {
                  key: 2,
                  variant: "tertiary-no-background",
                  wide: true,
                  onClick: $options.stopRecording
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_IconStop, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Stop recording')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["shown", "no-focus-trap"]))
}